const getMyEventById = (apiGet) => (id) => apiGet(`/me/events/${id}`);

export default getMyEventById;
